import React, { useEffect } from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, DatePicker, Form, Input, Modal, Space, Select } from "antd";
import "./agreement.css";
import useCustomerModal, { AgreementUpload, statusOptions } from "../../components/hoc_agreement"; // Import komponen Upload
import SalesDataCustomer from "../sales/sales_data_customer";
import moment from 'moment';

const Agreement: React.FC = () => {
    const [form] = Form.useForm();
    const {
        isModalVisible,
        showModal,
        handleCancel,
        handleSelectCustomer,
        handleSubmit,
        isEditing
    } = useCustomerModal(form);
    const existingDocument = Form.useWatch('document', form);
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    useEffect(() => {
        const savedData = localStorage.getItem('selectedCustomer');
        if (savedData) {
            const { id, no_agreement, cs_code, name_customer, reference_no, disc, expired, status, document } = JSON.parse(savedData);
            form.setFieldsValue({
                id,
                no_agreement,
                cs_code,
                name_customer,
                reference_no,
                disc,
                expired: moment(expired, 'DD/MM/YYYY'),
                status: parseInt(status),
                document: document
            });
            localStorage.removeItem('selectedCustomer'); // Hapus data setelah diisi
        }
    }, [form]);

    return (

        <div id="iau9" style={transformStyle}>
            {/* Grid Row 1 */}
            <div className="gjs-grid-row" id="iy8c">
                <div className="gjs-grid-column" id="ime2">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: '#/dashboard/browser_agreement',
                                title: (
                                    <>
                                        <UserOutlined />
                                        <span>Customer Data Agreement</span>
                                    </>
                                ),
                            },
                            {
                                title: "Agreement",
                            },
                        ]}
                    />
                </div>
            </div>

            {/* Grid Row 2 */}
            <div className="gjs-grid-row" id="ijldq">
                <div className="gjs-grid-column" id="i8s2m">
                    {/* Form Horizontal */}
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 550 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }} // Rata kiri label
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="No Agreement"
                            name="no_agreement"
                            style={{
                                marginBottom: "5px", width: '70%' // Menambahkan jarak antar item
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item label="Customer Code" style={{ marginBottom: 5 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Form.Item name="cs_code" style={{ width: '100px', marginRight: '8px' }}>
                                    <Input placeholder="Code"
                                    />
                                </Form.Item>

                                <Button name="modal-data-cs" type="primary" onClick={showModal} className="icon-button" style={{ marginBottom: '0px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="icon">
                                        <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                        <path
                                            fillRule="evenodd"
                                            d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                            clipRule="evenodd"
                                        />
                                        <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                    </svg>
                                </Button>

                                <Form.Item name="name_customer" style={{ flex: 1, marginLeft: '8px' }} >
                                    <Input placeholder="Name" />
                                </Form.Item>
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Reference No"
                            name="reference_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Disc % Agreement"
                            name="disc"
                            style={{
                                marginBottom: "5px", width: '40%',
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Expired Agreement"
                            name="expired"
                            style={{
                                marginBottom: "5px", // Menambahkan jarak antar item
                            }}
                        >
                            <DatePicker
                                format="DD/MM/YYYY" // Format dd/MM/yyyy
                                placeholder="Select date"
                                style={{ width: "40%", fontSize: "14px" }}
                                popupStyle={{ fontSize: "12px" }}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{ marginBottom: "5px", width: '60%' }}
                        >
                            <Select options={statusOptions} />
                        </Form.Item>
                        <Form.Item
                            label="Upload Documents"
                            name="document"
                            style={{ marginBottom: "5px" }}
                        >
                            <AgreementUpload initialFile={existingDocument} />
                        </Form.Item>
                        <Modal
                            title="Select Customer"
                            open={isModalVisible}
                            onCancel={handleCancel}
                            footer={null} // Hilangkan footer default
                            width={1200} // Sesuaikan lebar modal
                        >
                            <SalesDataCustomer
                                onSelect={handleSelectCustomer} // Fungsi untuk mengirim data ke form
                            />
                        </Modal>
                        <Space style={{ paddingTop: "20px" }}>
                            <Button
                                type="primary"
                                onClick={handleSubmit}
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }
                            >
                                {isEditing ? 'Update' : 'OK'}
                            </Button>
                            <Button
                                type="primary"
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "red",
                                    color: "white",
                                    border: "none",
                                }}
                            >
                                Cancel
                            </Button>
                        </Space>
                    </Form>
                </div>
            </div>

            {/* Grid Row 3 */}
            <div className="gjs-grid-row" id="izzpj">
                <div className="gjs-grid-column" id="iijn1"></div>
            </div>
        </div>
    );
};

export default Agreement;
